import { Component, OnInit, OnDestroy } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../.././auth.service';
import { Observable, timer } from 'rxjs';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-homelayout',
  templateUrl: './homelayout.component.html',
  styleUrls: ['./homelayout.component.css']
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  timervalue: Observable<Number> = timer(0, 100);
  subscription: any;
  constructor(private location: LocationStrategy, private authService: AuthService, private route: Router,
    private localService: LocalService) {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }
  username: string;
  ngOnInit() {
    //this.username = localStorage.getItem("username");
    this.username = this.localService.getJsonValue("username");

    this.subscription = this.timervalue.subscribe(() => {
      if (this.authService.isLoggednIn()) {
        return true;
      } else {
        this.route.navigate(["login"]);
        return false;
      }
    });

  }
  ngOnDestroy() {
    //console.log('timer destroyd');
    this.subscription.unsubscribe();
  }
}
